module.exports = __webpack_public_path__ + "img/02钱洪建.4d9824ab.jpg";